export const DATE_FORMATS = {
    s: 'YYYY-MM-DD HH:mm:ss',
    m: 'YYYY-MM-DD HH:mm',
    H: 'YYYY-MM-DD HH',
    D: 'YYYY-MM-DD',
    M: 'YYYY-MM',
    W: 'YYYY-wo',
    Q: 'YYYY-[Q]Q',
    Y: 'YYYY',
    HH: 'HH',
    Hm: 'HH:mm',
    Hms: 'HH:mm:ss',
};
export const NUMBER_COMPACT = [
    {
        compact: '천',
        conversion: 1000,
    },
    {
        compact: '만',
        conversion: 10000,
    },
    {
        compact: '억',
        conversion: 100000000,
    },
    {
        compact: '조',
        conversion: 1000000000000,
    },
];
